import React from 'react';
import { PasswordGenerator } from '../components/password-generator/PasswordGenerator';

const PasswordGeneratorPage: React.FC = () => {
  return <PasswordGenerator />;
};

export default PasswordGeneratorPage;
